/**
 * Default libphonenumber metadata (no per-country overrides).
 * Product scope: Ukraine (+380) only.
 */
import metadataMin from 'libphonenumber-js/metadata.min.json';

export const customPhoneMetadata = metadataMin;
